export const accountLevelInterface = {
  // _id: null,
  levelCode: '',
  levelName: '',
  priority: 100,
  share: 0,
  status: 'Active',
  skipPrefix: false
}
